import th from "./th";
const dictionary = (dict, word, params) => {
  let text = Object.keys(dict).length == 0 ? "" : dict[word];
  if (!text) return "";
  if (params && typeof params === "object") {
    text = text.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) =>
      params[key] !== undefined && params[key] !== null
        ? String(params[key])
        : match
    );
  }
  return text;
};
export default dictionary;
